import { Image, Link, Text, View } from '@react-pdf/renderer'
import React from 'react'
import { tw } from '~/components/pdfs'
import {
  type Company,
  type ListingBroker,
  type Organization,
  type User,
} from '~/models'
import { fmtName, fmtPhoneNumber, transformImageUrl } from '~/utils'

export default function PdfBrokerFooter({
  organization,
  user,
  company,
  brokers,
}: {
  organization: Organization
  user: User
  company?: Company
  brokers?: ListingBroker[]
}) {
  const renderBroker = (broker: User | ListingBroker) => {
    return (
      <View style={tw('flex flex-row gap-2')}>
        {broker.meta?.photo && (
          <View style={tw('h-12 w-12 shrink-0')}>
            <Image
              style={tw('rounded-full object-cover')}
              src={transformImageUrl(broker.meta?.photo?.url)}
            />
          </View>
        )}
        <View>
          <Text style={tw('text-sm font-semibold')}>
            {fmtName(broker.firstName, broker.middleName, broker.lastName)}
          </Text>
          <Link
            style={tw('text-xs text-muted no-underline')}
            href={`mailto:${broker.email}`}>
            <Text>{broker.email}</Text>
          </Link>
          {(broker.meta?.mobile || broker.meta?.office) && (
            <Link
              style={tw('mt-1 text-xs text-muted no-underline')}
              href={`tel:${broker.meta?.mobile}`}>
              <Text>
                {fmtPhoneNumber(broker.meta.mobile ?? broker.meta.office ?? '')}
              </Text>
            </Link>
          )}
        </View>
      </View>
    )
  }
  return (
    <View fixed style={tw('absolute bottom-0 left-0 right-0 px-8 pb-6')}>
      <View style={tw('flex flex-row items-center justify-between gap-4')}>
        <View style={tw('flex flex-row gap-2')}>
          {[user, ...(brokers ?? [])].map((broker) => (
            <React.Fragment key={broker._id}>
              {renderBroker(broker)}
            </React.Fragment>
          ))}
        </View>
        {company?.meta.logo && (
          <View style={tw('flex max-h-12 max-w-32 flex-row items-end')}>
            <Image
              style={tw('object-contain')}
              src={transformImageUrl(company.meta.logo.url)}
            />
          </View>
        )}
      </View>
      <View style={tw('mt-2 flex flex-row items-center gap-2')}>
        {organization.meta.logo && (
          <View style={tw('max-h-5 max-w-14')}>
            <Image
              style={tw('object-contain')}
              src={transformImageUrl(organization.meta.logo.url)}
            />
          </View>
        )}
        <Text style={tw('text-[7px] text-muted')}>
          The information in this report is provided by {organization.name} for
          informational purposes only. {organization.name} does not guarantee
          that the information is complete, accurate, or current.
        </Text>
      </View>
    </View>
  )
}
